var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.coLoader
    ? _c(
        "div",
        [
          _vm.coTickets
            ? _c("sub-navigation-title", {
                attrs: {
                  title: _vm.coTicketSubject,
                  source: _vm.coTickets,
                  color: "#00dac2",
                  "text-field": "subject",
                  "load-more-visible": _vm.visible
                },
                on: {
                  loadMore: _vm.handleGoBack,
                  click: _vm.handleTicketClick
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(data) {
                      return data.item
                        ? [
                            _c(
                              "v-list-tile-title",
                              { staticStyle: { height: "30px" } },
                              [
                                _c(
                                  "label",
                                  { staticStyle: { "font-size": "16px" } },
                                  [_vm._v(_vm._s(data.item.text))]
                                ),
                                _vm._v(" "),
                                _vm.getUnreadForTicket(data.item) > 0
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticStyle: {
                                          "min-width": "20px",
                                          "min-height": "20px",
                                          width: "20px",
                                          height: "20px",
                                          "box-shadow": "transparent",
                                          float: "right",
                                          "margin-top": "1px"
                                        },
                                        attrs: {
                                          small: "",
                                          fab: "",
                                          color: "secondary"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n          " +
                                            _vm._s(
                                              _vm.getUnreadForTicket(data.item)
                                            )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        : undefined
                    }
                  }
                ]),
                model: {
                  value: _vm.dtMenu,
                  callback: function($$v) {
                    _vm.dtMenu = $$v
                  },
                  expression: "dtMenu"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-list",
            { staticClass: "ticket-subnav__ticket-item" },
            _vm._l(_vm.coChannels, function(channel, index) {
              return _c(
                "v-list-tile",
                {
                  key: index,
                  class:
                    channel.id === _vm.currentChannelId
                      ? "ticket-subnav__add-participant--active channel--active"
                      : ""
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "", "align-center": "" } },
                    [
                      _c(
                        "v-list-tile-content",
                        { staticStyle: { position: "relative" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex",
                              staticStyle: {
                                cursor: "pointer",
                                display: "inline"
                              },
                              on: {
                                click: function($event) {
                                  _vm.handleChannelClick(channel)
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "ticket-subnav__ticket-item--dot align-self-center"
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "ticket-group-title--text ml-2"
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(channel.channelName) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              channel.unreadMessageNumber
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "ticket-subnav__unread-number"
                                    },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(channel.unreadMessageNumber)
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-sub-title",
                            {
                              on: {
                                click: function($event) {
                                  _vm.handleChannelClick(channel)
                                }
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "light-dark",
                                domProps: { textContent: _vm._s(channel.date) }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.getVisibility(channel)
                            ? _c(
                                "button",
                                {
                                  staticClass: "ticket-subnav__add-participant",
                                  on: {
                                    click: function($event) {
                                      _vm.handleAddParticipant(channel)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("add")])],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "v-list",
            [
              _vm.canCreateGroup
                ? _c(
                    "v-list-tile",
                    {
                      staticStyle: {
                        "border-top": "0.5px solid #404040",
                        "margin-top": "10px"
                      },
                      on: { click: _vm.handleCreateNewGroup }
                    },
                    [
                      _c(
                        "v-list-tile-content",
                        { staticStyle: { color: "inherit !important" } },
                        [
                          _c("v-list-tile-title", [
                            _c("div", {
                              staticClass: "ticket-subnav__ticket-item--dot"
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "sub-title--text",
                              staticStyle: { display: "inline-block" },
                              domProps: {
                                textContent: _vm._s(_vm.$t("BTN_CREATE_GROUP"))
                              }
                            })
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("side-modal", {
            attrs: {
              visible: _vm.dtModalVisible,
              loading: _vm.dtRecordChannelLoading
            },
            on: {
              "update:visible": function($event) {
                _vm.dtModalVisible = $event
              },
              save: _vm.handleSaveChannel
            },
            model: {
              value: _vm.dtChannalRegistration,
              callback: function($$v) {
                _vm.dtChannalRegistration = $$v
              },
              expression: "dtChannalRegistration"
            }
          }),
          _vm._v(" "),
          _c("side-modal-add-participant", {
            attrs: {
              visible: _vm.dtModalAddParticipantVisible,
              channel: _vm.dtChannel
            },
            on: {
              "update:visible": function($event) {
                _vm.dtModalAddParticipantVisible = $event
              }
            }
          })
        ],
        1
      )
    : _c("ticket-sidebar-loader")
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c95ed2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c95ed2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-sidebar-ticket-groups/template.html
// module id = null
// module chunks = 